// Redirects the bare /collections path (no handle) to /collections/all,
// since Shopify has no page there.
(function () {
  var path = window.location.pathname.replace(/\/+$/, '');
  if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections$/i.test(path)) {
    window.location.replace(path + '/all' + window.location.search + window.location.hash);
  }
})();
